type OutfitLayerType = 'default' | 'compact';
export type Sash = {
  title: string;
  background: string;
};
export interface JackpotType {
  value: number;
  currencySymbol: string;
  timestamp: number;
  increaseVelocity: number;
  updateInterval?: number;
}
interface CommonLayerProps {
  infoIcon?: boolean;
  outfit?: OutfitLayerType;
  sash?: Sash;
  jackpot?: JackpotType;
}
export type GameTableType =
  | 'Baccarat'
  | 'Blackjack'
  | 'DragonTiger'
  | 'ScalableBlackjack'
  | 'Roulette'
  | 'Poker'
  | 'MoneyWheel'
  | 'TopCard'
  | 'Trivia'
  | 'Monopoly'
  | 'SicBo'
  | 'DealNoDeal'
  | 'SidebetCity'
  | 'LightningDice';

export type PortalVerticalTableGameType = {
  name: string;
  provider: string;
  type?: string;
  online: TableOnline;
  overlay?: TableOverlay;
  dealer: TableDealer;
  playersInfo: string;
  stake: string;
};

export type ImageType = {
  source: {
    normal: string;
    retina?: string;
    base?: string;
  };
  alt: string;
};

export interface PortalVerticalGameTilePropTypes extends CommonLayerProps {
  gameDetailsPath: string;
  gameLaunchPath: string;
  id: string;
  presentation_code: string;
  transaction_code: string;
  name: string;
  title: string;
  info_title: string;
  sizedImages?: {
    smallTile: {
      min?: number;
      max?: number;
      src: {
        normal: string;
        retina?: string;
      };
    }[];
    largeTile: {
      min?: number;
      max?: number;
      src: {
        normal: string;
        retina?: string;
      };
    }[];
  };
  info?: string[];
  infoPageImages?: {
    logo: ImageType;
    background: {
      min?: number;
      max?: number;
      src: { normal: string; retina?: string };
    }[];
  };
  image: ImageType;
  bannerImage?: Banner;
  jackpot?: JackpotType;
  jackpotCode?: string;
  jackpotVelocity?: number;
  table?: Table;
  launchUrl: string;
  practiceUrl?: string;
  provider: string;
  integration: string;
  description: string;
  type?: string;
  gridType?: string;
  tableFetching: boolean;
  banner?: Banner;
  table_id?: string;
  features?: string[];
  seo?: {
    title?: string;
    description?: string;
  };
  tracking_metadata?: {
    title: string;
  };
  bingo?: {
    numberOfPlayers: number;
    prize: string;
    startTime: number;
    currency: string;
    displayName: string;
    timeLeft: number;
    formattedPrize: string;
  };
  sectionTitle?: string;
  gamePosition?: number;
}

interface Banner {
  type: 'image' | 'video';
  source: {
    normal: string;
    retina?: string;
  };
  alt: string;
}

export interface TableStake {
  currencySymbol: string;
  min: number;
  max?: number;
  text?: string;
}

interface TableDealer {
  id?: string;
  name?: string;
  thumbnail?: string;
}

interface TableOverlay {
  visibility: 'always' | 'hover';
  icon: string;
  title: string;
  cta?: {
    size?: 'big' | 'normal';
    theme?: 'default' | 'hollow';
    label?: 'string';
  };
}

interface TableOnline {
  open: boolean;
  onlineAt?: number;
  startTime?: string;
}

type TableDealerResultsColorType =
  | 'black-roulette'
  | 'red-roulette'
  | 'green-roulette'
  | 'lightning-roulette'
  | 'yellow-multiple-roulette'
  | 'blue-topcard'
  | 'red-topcard'
  | 'gold-topcard'
  | 'blue-moneywheel'
  | 'gold-moneywheel'
  | 'green-moneywheel'
  | 'orange-moneywheel'
  | 'red-moneywheel'
  | 'violet-moneywheel'
  | 'white-moneywheel'
  | 'yellow-moneywheel';

export interface TableDealerResults {
  value: string;
  color?: TableDealerResultsColorType;
  highlight?: boolean;
  tooltip?: string;
}

interface TableDealerResultsMultiple {
  values: {
    value: string;
    color?: string;
  };
  highlight?: boolean;
}

export interface Table {
  id?: string;
  stake: TableStake;
  overlay?: TableOverlay;
  players?: number;
  seats?: number;
  name: string;
  provider: string;
  online: TableOnline;
  type: string;
  dealer: TableDealer;
  results?: TableDealerResults[];
  resultsMultiple?: TableDealerResultsMultiple[];
  locale?: string;
  currencyCode?: string;
}

export enum GameMode {
  Standard = 'Standard',
  Practice = 'Practice Game Launch',
}

export enum LaunchStrategyEnum {
  newWindow = 'newWindow',
  modalForMobile = 'modalForMobile',
}

export type LaunchStrategyType = LaunchStrategyEnum | 'default';

export type GameLaunchStrategies = Record<string, LaunchStrategyEnum>;

export enum CloseStrategyEnum {
  internal = 'internal',
  external = 'external',
}

export type CloseStrategyType = keyof typeof CloseStrategyEnum;

export type GameCloseStrategies = Record<string, CloseStrategyEnum>;
